<script>
import { sexTypes, homeTypes, marriageStatuses, numberOfChildren, workForms, bizTypes, jobTypes, staffNums, repaymentDates, residenceYears } from '../../constants/constant'
export default {
  methods: {
    substrNkyNgt (start, length) {
      try {
        if (this.userData.nky_ngt) {
          return (this.userData.nky_ngt).toString().substr(start, length)
        }
        return ''
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    substrNshNgt (start, length) {
      try {
        if (this.userData.nsh_ngt) {
          return (this.userData.nsh_ngt).toString().substr(start, length)
        }
        return ''
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    substrBth (start, length) {
      try {
        if (this.userData.bth) {
          return (this.userData.bth).toString().substr(start, length)
        }
        return ''
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setGrossSalary: function () {
      try {
        let grossSalary = String(this.input_gross_salary).trim()
        this.userData.gross_salary = grossSalary
        if (grossSalary && !isNaN(grossSalary)) {
          if (grossSalary.indexOf('.') !== 0) {
            this.userData.gross_salary = parseInt(grossSalary) * 10000
          }
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setNkyNgt () {
      try {
        if (this.nkyNgtYyyy && this.nkyNgtMm) {
          this.userData.nky_ngt = this.nkyNgtYyyy.toString().trim() + ('0' + this.nkyNgtMm.toString().trim()).slice(-2) + '01'
        } else {
          this.userData.nky_ngt = ''
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setNkyNgtYyyy () {
      try {
        if (this.userData.nky_ngt) {
          this.nkyNgtYyyy = Number(this.userData.nky_ngt.toString().substr(0, 4))
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setNkyNgtMm () {
      try {
        if (this.userData.nky_ngt) {
          this.nkyNgtMm = Number(this.userData.nky_ngt.toString().substr(4, 2))
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setNshNgt () {
      try {
        if (this.nshNgtYyyy && this.nshNgtMm) {
          this.userData.nsh_ngt = this.nshNgtYyyy.toString().trim() + ('0' + this.nshNgtMm.toString().trim()).slice(-2) + '01'
        } else {
          this.userData.nsh_ngt = ''
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setNshNgtYyyy () {
      try {
        if (this.userData.nsh_ngt) {
          this.nshNgtYyyy = Number(this.userData.nsh_ngt.toString().substr(0, 4))
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setNshNgtMm () {
      try {
        if (this.userData.nsh_ngt) {
          this.nshNgtMm = Number(this.userData.nsh_ngt.toString().substr(4, 2))
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setPhoneAu (data) {
      this.userData.phone_au_1 = data.phone1
      this.userData.phone_au_2 = data.phone2
      this.userData.phone_au_3 = data.phone3
    },
    setPhoneMobile (data) {
      this.userData.phone_mobile_1 = data.phone1
      this.userData.phone_mobile_2 = data.phone2
      this.userData.phone_mobile_3 = data.phone3
    },
    setHasPhoneAu () {
      this.hasPhoneAu = !!this.userData.phone_au_1 && !!this.userData.phone_au_2 && !!this.userData.phone_au_3
    },
    setHasPhoneMobile () {
      this.hasPhoneMobile = !!this.userData.phone_mobile_1 && !!this.userData.phone_mobile_2 && !!this.userData.phone_mobile_3
    },
    setHasSex () {
      this.hasSex = !!this.userData.eva_sbt
    },
    setHasBth () {
      this.hasBth = !!this.userData.eva_birth
    },
    setOfficePhone (data) {
      this.userData.office_phone_1 = data.phone1
      this.userData.office_phone_2 = data.phone2
      this.userData.office_phone_3 = data.phone3
    },
    createDisplayPhone (phone1, phone2, phone3) {
      let list = []
      if (phone1) {
        list.push(phone1)
      }
      if (phone2) {
        list.push(phone2)
      }
      if (phone3) {
        list.push(phone3)
      }
      return list.join('-')
    }
  },
  computed: {
    displayNameKanji () {
      return this.userData.lastname_kanji + ' ' + this.userData.firstname_kanji
    },
    displayNameKana () {
      return this.userData.lastname_kana + ' ' + this.userData.firstname_kana
    },
    displayBth () {
      return this.bthYyyy + '年 ' + this.bthMm + '月 ' + this.bthDd + '日'
    },
    bthYyyy () {
      return this.substrBth(0, 4)
    },
    bthMm () {
      if (this.substrBth(4, 2)) {
        return String(Number(this.substrBth(4, 2)))
      }
      return ''
    },
    bthDd () {
      if (this.substrBth(6, 2)) {
        return String(Number(this.substrBth(6, 2)))
      }
      return ''
    },
    displaySex () {
      for (let sexType of sexTypes) {
        if (sexType.value === this.userData.sex) {
          return sexType.name
        }
      }
      return ''
    },
    displayRepaymentDate () {
      for (let repaymentDate of repaymentDates) {
        if (repaymentDate.value === this.userData.repayment_date) {
          return repaymentDate.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayPostcode () {
      try {
        return (this.userData.postcode).toString().substr(0, 3) + '-' + (this.userData.postcode).toString().substr(3, 4)
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    displayAddress () {
      return this.userData.address_region + this.userData.address_city + this.userData.address_street + this.userData.address_building
    },
    displayHomeType () {
      for (let homeType of homeTypes) {
        if (homeType.value === this.userData.home_type) {
          return homeType.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayJkyNgt () {
      for (let residenceYear of residenceYears) {
        if (residenceYear.value === this.userData.nky_ngt) {
          return residenceYear.name
        }
      }
      return ''
    },
    displayNkyNgt () {
      return this.displayNkyNgtYyyy + '年' + this.displayNkyNgtMm + '月〜'
    },
    displayNkyNgtYyyy () {
      return this.substrNkyNgt(0, 4)
    },
    displayNkyNgtMm () {
      if (this.substrNkyNgt(4, 2)) {
        return String(Number(this.substrNkyNgt(4, 2)))
      }
      return ''
    },
    displayRentLoanAmount () {
      return Number(this.userData.rent_loan_amount).toLocaleString() + '円／月'
    },
    displayMarriageStatus () {
      for (let marriageStatus of marriageStatuses) {
        if (marriageStatus.value === this.userData.marriage_status) {
          return marriageStatus.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayNumberOfChildren () {
      for (let numberOfChild of numberOfChildren) {
        if (numberOfChild.value === this.userData.number_of_children) {
          return numberOfChild.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayEzMail () {
      return this.userData.ez_mail ? this.userData.ez_mail : '未設定'
    },
    displayMail1 () {
      return this.userData.mail_1 ? this.userData.mail_1 : '未設定'
    },
    displayMail2 () {
      return this.userData.mail_2 ? this.userData.mail_2 : '未設定'
    },
    displayLoanMail () {
      return this.userData.loan_mail ? this.userData.loan_mail : '未設定'
    },
    displayLoanMailDisp () {
      return this.userData.loan_mail_disp ? this.userData.loan_mail_disp : '未設定'
    },
    displayWorkForm () {
      for (let workForm of workForms) {
        if (workForm.value === this.userData.work_form) {
          return workForm.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayBizType () {
      for (let bizType of bizTypes) {
        if (bizType.value === this.userData.biz_type) {
          return bizType.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayJobType () {
      for (let jobType of jobTypes) {
        if (jobType.value === this.userData.job_type) {
          return jobType.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayStaffNum () {
      for (let staffNum of staffNums) {
        if (staffNum.value === this.userData.staff_num) {
          return staffNum.name.replace('<br>', '')
        }
      }
      return ''
    },
    displayNshNgt () {
      return this.displayNshNgtYyyy + '年' + this.displayNshNgtMm + '月〜'
    },
    displayNshNgtYyyy () {
      return this.substrNshNgt(0, 4)
    },
    displayNshNgtMm () {
      if (this.substrNshNgt(4, 2)) {
        return String(Number(this.substrNshNgt(4, 2)))
      }
      return ''
    },
    displayPhoneAu () {
      return this.createDisplayPhone(this.userData.phone_au_1, this.userData.phone_au_2, this.userData.phone_au_3)
    },
    displayPhoneMobile () {
      return this.hasPhoneMobile ? this.createDisplayPhone(this.userData.phone_mobile_1, this.userData.phone_mobile_2, this.userData.phone_mobile_3) : '未設定'
    },
    displayOfficePhone () {
      return this.createDisplayPhone(this.userData.office_phone_1, this.userData.office_phone_2, this.userData.office_phone_3)
    },
    displayGrossSalary () {
      return parseInt(this.userData.gross_salary / 10000) + '万円'
    },
    showWorkFormMessage () {
      try {
        return (this.userData.work_form === '09' || this.userData.work_form === '10')
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    showWorkFormMessage02 () {
      try {
        return (this.userData.work_form === '07')
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    auUser () {
      return this.userData.id_type === '0'
    },
    localUser () {
      return this.userData.id_type === '99'
    },
    showLoanMail () {
      return !this.userData.ez_mail && !this.userData.mail_1 && !this.userData.mail_2
    },
    showDefaultMail () {
      return !this.showLoanMail
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixin/UserData.vue